import { ComponentRef, Directive, Input, OnChanges, OnInit, ViewContainerRef } from '@angular/core';
import { NkChanges } from '@nk/utils-lib';
import { EntityWithUuid, NkCardListConfig, NkCardListItemDetails } from '../card-list.utils';

@Directive({
  selector: '[nkCardListItemDetails]',
  standalone: true,
})
export class CardListItemDetailsDirective<Entity extends EntityWithUuid> implements OnInit, OnChanges {
  @Input() public highlightText: string | undefined;
  @Input() public nkCardListItemDetailsComponent: NkCardListConfig<Entity>['detailsComponent'];
  @Input() public set entity(entity: Entity | undefined) {
    this._entity = entity;
    this._updateValue(this._entity);
  }
  public get entity(): Entity | undefined {
    return this._entity;
  }
  private _entity: Entity | undefined;
  private _componentRef: ComponentRef<NkCardListItemDetails<Entity>> | undefined;

  constructor(private _container: ViewContainerRef) {}

  private _updateValue(entity: Entity | undefined): void {
    if (this._componentRef) {
      if (typeof entity !== 'undefined') {
        this._componentRef.instance.entity = entity;
      }
      this._componentRef.instance.highlightText = this.highlightText;
    }
  }

  public ngOnInit(): void {
    if (this.nkCardListItemDetailsComponent) {
      this._componentRef = this._container.createComponent(this.nkCardListItemDetailsComponent);
      this._updateValue(this.entity);
    }
  }

  // TODO: fix me
  // @ts-ignore
  public ngOnChanges(changes: NkChanges<CardListItemDetailsDirective<Entity>>): void {
    if (changes.highlightText && this._componentRef?.instance) {
      this._componentRef.instance.highlightText = changes.highlightText.currentValue;
    }
  }
}
